import apiClient from './client'
import type {
    User,
    UserMergePreviewResponse,
    UserMergeRequest,
    UserRole,
} from '../types'

interface PageResponse<T> {
    content: T[]
    totalElements: number
    totalPages: number
    size: number
    number: number
}

export const fetchUsers = async ({
                                     page = 0,
                                     size = 20,
                                     query,
                                     role
                                 }: {
    page?: number
    size?: number
    query?: string
    role?: UserRole
}): Promise<PageResponse<User>> => {
    const params = new URLSearchParams()
    params.append('page', page.toString())
    params.append('size', size.toString())
    if (query) params.append('query', query)
    if (role) params.append('role', role)

    const response = await apiClient.get(`/users?${params.toString()}`)
    return response.data.data
}

export const searchUsers = async (query: string): Promise<User[]> => {
    const response = await apiClient.get(`/users?query=${encodeURIComponent(query)}`)
    return response.data.data.content
}

export const searchPlayers = async (query: string): Promise<User[]> => {
    const response = await apiClient.get(`/players/search?query=${encodeURIComponent(query)}`)
    return response.data.data
}

export const getUserById = async (userId: number): Promise<User> => {
    const response = await apiClient.get(`/users/${userId}`)
    return response.data.data
}

export const updateUser = async (
    userId: number,
    data: Partial<User>
): Promise<void> => {
    const response = await apiClient.put(`/users/${userId}`, data)
    return response.data.data
}

export const createUser = async (
    data: {
        email?: string
        phone?: string
        fullName: string
        role?: UserRole
        birthDate?: string
        military?: boolean
        serviceTableId?: number | null
    }
): Promise<User> => {
    const response = await apiClient.post('/users', data)
    return response.data.data
}

export const deleteUser = async (userId: number): Promise<void> => {
    const response = await apiClient.delete(`/users/${userId}`)
    return response.data.data
}

export const changeUserRole = async (
    userId: number,
    role: UserRole
): Promise<void> => {
    const response = await apiClient.put(`/users/${userId}/role`, { role })
    return response.data.data
}

export const previewUserMerge = async (
    request: UserMergeRequest
): Promise<UserMergePreviewResponse> => {
    const response = await apiClient.post('/users/merge/preview', request)
    return response.data.data
}

export const confirmUserMerge = async (
    request: UserMergeRequest
): Promise<User> => {
    const response = await apiClient.post('/users/merge', request)
    return response.data.data
}
